// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pTXtx","deleteForm":"styles_deleteForm__NKpry","title":"styles_title__P1NaC","description":"styles_description__Mym1S","error":"styles_error__dbOG1"};